import { render } from "./upcomingCourses.vue?vue&type=template&id=753c6d7a"
import script from "./upcomingCourses.vue?vue&type=script&lang=js"
export * from "./upcomingCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__